import React, { useState, useEffect, useMemo } from "react"
import lodash from "lodash"

import { useField } from '../../../../1stlog-ui/src/components/Field'

const useRelevantAddressFields = () => {
  const reference = useField("reference")
  const name1 = useField("name1")
  const name2 = useField("name2")
  const name3 = useField("name3")
  const street = useField("street")
  const streetNumber = useField("streetNumber")
  const streetNumberAddition = useField("streetNumberAddition")
  const country = useField("country")
  const zip = useField("zip")
  const city = useField("city")
  const prename = useField("prename")
  const surname = useField("surname")
  const phone1 = useField("phone1")
  const mail = useField("mail")
  const eori = useField("eori")
  const ustid = useField("ustid")

  return {
    reference,
    name1,
    name2,
    name3,
    street,
    streetNumber,
    streetNumberAddition,
    country,
    zip,
    city,
    prename,
    surname,
    phone1,
    mail,
    eori,
    ustid
  }
}

const useAddressSearchPayload = () => {
  const values = useRelevantAddressFields()

  const payload = useMemo(() => {
    const result = {}
    lodash.forOwn(values, (value, key) => {
      if (!value || String(value) === "") return
      const appendWildcard = !["country"].includes(key)
      if (key === "country") {
        return
      }
      lodash.set(result, key, `${value}${appendWildcard ? "%" : ""}`)
      // TODO: proper prefix/suffix wildcard for name1, reference
    })

    // return undefined if payload is not allowed as search

    if (
      lodash.isEmpty(result) ||
      (lodash.size(result) <= 1 && lodash.has(result, "country"))
    ) {
      return undefined
    }

    return result
  }, [values])

  return payload
}

export default useAddressSearchPayload
